import React from 'react';

interface MobileMenuProps {
    isOpen: boolean;
    onClose: () => void;
    onValidate: () => void;
    onRemove: () => void;
    canValidate: boolean;
    isRegistered: boolean;
    isViolator: boolean;
    isValidated: boolean;
    position: { x: number; y: number };
}

const MobileMenu: React.FC<MobileMenuProps> = ({
    isOpen,
    onClose,
    onValidate,
    onRemove,
    canValidate,
    isRegistered,
    isViolator,
    isValidated,
    position
}) => {
    if (!isOpen) return null;

    const handleOptionClick = (action: () => void) => {
        action();
        onClose();
    };

    return (
        <>
            <div className="mobile-menu-overlay" onClick={onClose} />
            <div
                className="mobile-menu"
                style={{
                    position: 'fixed',
                    top: position.y,
                    right: window.innerWidth - position.x,
                    zIndex: 1000
                }}
            >
                {canValidate && !isRegistered && (
                    <div
                        className="mobile-menu-item"
                        onClick={() => handleOptionClick(onValidate)}
                    >
                        {isValidated ? 'Remove Validation' : 'Validate'}
                    </div>
                )}
                <div
                    className="mobile-menu-item"
                    onClick={() => handleOptionClick(onRemove)}
                >
                    Remove
                </div>
            </div>
        </>
    );
};

export default MobileMenu; 